module.exports = __webpack_public_path__ + "img/20201106_083411.6cc721ef.jpg";